<div id="session-new-container" class="container">
    <h1>
        <i class="fa fa-bookmark-o"></i> {{ 'session-form.create' | translate }}
    </h1>
    <session-form
        [currentSession]="currentSession"
        type="create"
    ></session-form>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/create/create.component.html